var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('DataEntityList', {
    attrs: {
      "initial-value": _vm.initialValue,
      "params": _vm.params,
      "get": _vm.$api.constructor.catalog
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var pageCurrent = _ref.pageCurrent,
            get = _ref.get,
            pageCount = _ref.pageCount,
            itemsCount = _ref.itemsCount,
            activeSort = _ref.activeSort,
            error = _ref.error,
            response = _ref.response,
            list = _ref.list,
            sort = _ref.sort,
            sortList = _ref.sortList,
            changePage = _ref.changePage,
            loadMore = _ref.loadMore,
            loading = _ref.loading,
            success = _ref.success;
        return [_c('CatalogPage', {
          attrs: {
            "list": list,
            "data": response,
            "pagination": {
              count: pageCount,
              current: pageCurrent,
              itemQuantity: itemsCount
            },
            "loading": loading,
            "link-page": _vm.linkPage,
            "availability-sort": _vm.params.availabilitySort,
            "error": error,
            "sort-list": sortList,
            "active-sort": activeSort
          },
          on: {
            "sort": function ($event) {
              sort($event) + _vm.changeParams({
                sort: $event.value
              }) + _vm.changeQuery({
                sort: $event.value
              });
            },
            "change-page": function ($event) {
              changePage($event) + _vm.changeParams({
                page: $event
              }) + _vm.changeQuery({
                page: $event
              });
            },
            "load-more": function ($event) {
              loadMore($event) + _vm.changeParams({
                page: $event
              }) + _vm.changeQuery({
                page: $event
              });
            },
            "update": function ($event) {
              _vm.params = $event;
            },
            "change-query": function ($event) {
              return _vm.changeQuery($event);
            },
            "change-params": function ($event) {
              return _vm.changeParams($event);
            },
            "refresh": function ($event) {
              return get();
            }
          }
        }, [success ? _c('SearchSemantic', {
          attrs: {
            "data": _vm.semanticData(response)
          }
        }) : _vm._e()], 1)];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }